import React, {Component, Fragment} from 'react';
import ReactHtmlParser from 'react-html-parser';
import {trans} from "../../../../utils/helpers";
import Loader from "../../../../components/common/Spinners/Loader";
import moment from "moment";
import Button from "../../../../components/common/Buttons/Button";

class ConfirmationStep extends Component {

	render() {

		const {
			createOrderLoader,
			createOrderError,
			handleBlur,
			setFieldValue,
			values,
			errors,
			touched,
			handleChangeStep,
			isSubmitting,
		} = this.props;

		return (
			<div className="form-section">

				<h4>{trans('en-us', 'signupToServiceScreen.confirmOrder.title')}</h4>

				<p className="form-divider">
					<i className="fas fa-map-marker-alt" /> {values.formatedAddress}
				</p>

				{createOrderLoader
				? <Loader />
				:
				<>
					<dl className="card-datalist">

						<div className="card-datalist-row">
							<dt>First Name</dt>
							<dd>{values.account.accountHolder.firstName}</dd>
						</div>

						<div className="card-datalist-row">
							<dt>Last Name</dt>
							<dd>{values.account.accountHolder.lastName}</dd>
						</div>

						<div className="card-datalist-row">
							<dt>Phone Number</dt>
							<dd>{values.account.accountHolder.mobileNumber.number}</dd>
						</div>

						<div className="card-datalist-row">
							<dt>Email</dt>
							<dd>{values.account.accountHolder.personalEmail}</dd>
						</div>

						{values.order.plans[0].planBundleDescription &&
							<div className="card-datalist-row">
								<dt>Bundle</dt>
								<dd>{values.order.plans[0].planBundleDescription}</dd>
							</div>
						}

						<div className="card-datalist-row">
							<dt>Plan{values.order.plans.length > 1 ? "s" : ""}</dt>
							<dd>
								{values.order.plans.map(plan => (<>{plan.planDescription}<br/></>))}
							</dd>
						</div>

						<div className="card-datalist-row">
							<dt>Appointment Date</dt>
							<dd>
								{
									values.appointmentDate
										? moment(values.appointmentDate).format("MM/DD/YYYY") +
											(moment(values.appointmentDate).format("HH:mm") !== "00:00"
												? " " + moment(values.appointmentDate).format("hA") + "-" + moment(values.appointmentDate).add(2, 'hour').format("hA")
												: ""
											)
										: "No appointment created"
								}
							</dd>
						</div>

					</dl>

					<p className="text-xs">{trans('en-us', 'signupToServiceScreen.confirmOrder.termsAndConditions')}</p>
					<div className="form-group custom-checkbox">
						<input
							type="checkbox"
							className="custom-control-input"
							id="agree-tc"
							name="account.termsAndCondition"
							checked={values.account.termsAndCondition}
							onChange={(e) => setFieldValue('account.termsAndCondition', e.target.checked)}
							onBlur={handleBlur}
							disabled={isSubmitting}
						/>
						<label className="custom-control-label" htmlFor="agree-tc">
							{ReactHtmlParser(
								trans('en-us', 'termsAndConditionsLink')
							)}
						</label>
						{errors.account && errors.account.termsAndCondition && touched.account && touched.account.termsAndCondition && (
							<div style={{display: 'block'}} className="invalid-feedback">
								{errors.account.termsAndCondition}
							</div>
						)}
					</div>

					{createOrderError && <p style={{ color: 'red' }}>{createOrderError}</p>}

					<div className="form-group form-group-footer">

						<button
							disabled={isSubmitting}
							onClick={() => handleChangeStep('schedule-appointment')}
							type="button"
							className="btn btn-quick"
						>
							Back
						</button>

						<button
							disabled={isSubmitting ||  (errors.account && errors.account.termsAndCondition && touched.account && touched.account.termsAndCondition)}
							type="submit"
							className="btn btn-primary"
						>
							Continue
							{isSubmitting && <>&nbsp;<i className="fas fa-fw fa-spin fa-spinner" /></>}
						</button>

					</div>
				</>
				}

			</div>
		);
	}
}

export default ConfirmationStep;
